export default {"src":"/_next/static/media/filter.ea196678.svg","height":24,"width":25};